import React from "react";
import { MentionsInput, Mention } from "react-mentions";
import { isEmpty } from "../hooks/constants";
import defaultStyle from "@components/MarketVisitReport/defaultStyle";
import defaultMentionStyle from "@components/MarketVisitReport/defaultMentionStyle";
import styles from "@components/MarketVisitReport/MarketVisitReport.module.css";

/**
 * CompetitionSection Component
 * Competition activity and products section of Market Visit Report
 * 
 * @param {Object} formData - Form data
 * @param {Function} onChange - Handler for form field changes
 * @param {Array} productList - List of products for mentions
 * @param {Object} characterLimitValidation - Character limit validation errors
 * @param {Object} formValidation - Form validation errors
 * @param {String} userType - Type of user
 * @param {Boolean} disable - Form disable state
 */
const CompetitionSection = ({
  formData,
  onChange,
  productList,
  characterLimitValidation,
  formValidation,
  userType,
  disable,
}) => {
  // Don't render for MH3 and RBDM Collaborator user types
  if (userType === "MH3" || userType === "RBDM Collaborator") {
    return null;
  }

  return (
    <>
      {/* Section Header */}
      <div className={`row m-0 ${styles.MarketVisitReport__headingBox}`}>
        <div className={`col-8 p-0 ${styles.MarketVisitReport__heading}`}>
          Competition
        </div>
      </div>

      {/* Competition Activity */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Key Observations regarding competition activity in overall market
          visited:
          <span style={{ color: "red", fontSize: "1rem" }}>*</span>
        </label>
        <MentionsInput
          className={styles.MarketVisitRepor__input}
          value={
            isEmpty(formData?.competitionActivity)
              ? ""
              : formData?.competitionActivity
          }
          maxLength={2001}
          onChange={(e) => {
            onChange({
              target: {
                name: "competitionActivity",
                value: e.target.value,
              },
            });
          }}
          style={defaultStyle}
          disabled={disable}
        >
          <Mention
            trigger="@p"
            data={productList}
            style={defaultMentionStyle}
          />
        </MentionsInput>
        {characterLimitValidation?.competitionActivity && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.competitionActivity}
          </p>
        )}
        {!formData?.competitionActivity &&
          formValidation?.competitionActivity && (
            <p className={styles.MarketVisitReport__validationErrors}>
              {formValidation?.competitionActivity}
            </p>
          )}
      </div>

      {/* Competition Products */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Key Competition products which are affecting our sales:
          <span style={{ color: "red", fontSize: "1rem" }}>*</span>
        </label>
        <MentionsInput
          className={styles.MarketVisitRepor__input}
          value={
            isEmpty(formData?.competitionProducts)
              ? ""
              : formData?.competitionProducts
          }
          maxLength={501}
          onChange={(e) => {
            onChange({
              target: {
                name: "competitionProducts",
                value: e.target.value,
              },
            });
          }}
          style={defaultStyle}
          disabled={disable}
        >
          <Mention
            trigger="@p"
            data={productList}
            style={defaultMentionStyle}
          />
        </MentionsInput>
        {characterLimitValidation?.competitionProducts && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.competitionProducts}
          </p>
        )}
        {!formData?.competitionProducts &&
          formValidation?.competitionProducts && (
            <p className={styles.MarketVisitReport__validationErrors}>
              {formValidation?.competitionProducts}
            </p>
          )}
      </div>
    </>
  );
};

export default CompetitionSection;
